import { useEffect, type ReactNode } from 'react';
import { Outlet } from 'react-router';
import useBrand from '../../hooks/useBrand';
import CatalogProvider from '../../store/CatalogProvider';
import Header from './Header';
import Footer from './Footer';
import ErrorModal from '../ErrorModal';
import CartWidget from '../CartWidget';
import BulkRatesModal from '../BulkRatesModal';
import FeeDescriptionModal from '../FeeDescriptionModal';

export default function Layout({ children }: { children?: ReactNode }) {
  const brand = useBrand();
  const domain = brand?.domain;
  const header = brand?.header;
  const cssFileUrl = brand?.cssFileUrl;

  // Load the CSS file dynamically based on the brand's resources
  useEffect(() => {
    if (!domain || !header || !cssFileUrl) return;

    const link = document.createElement('link');
    link.href = cssFileUrl;
    link.rel = 'stylesheet';

    document.head.appendChild(link);

    return () => {
      // Clean up the link when component unmounts
      document.head.removeChild(link);
    };
  }, [domain, cssFileUrl, header]);

  return (
    <CatalogProvider>
      <Header />

      <main id="content-wrap">{children ?? <Outlet />}</main>

      <Footer />

      <CartWidget />

      <BulkRatesModal />
      <FeeDescriptionModal />

      <ErrorModal />
    </CatalogProvider>
  );
}
